import { getAuthStatus } from '../data/membership-data-service';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

export const useAuthStatus = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            const authStatus = await getAuthStatus();

            if(!authStatus?.loggedIn) {
                navigate('/');
            }

            setLoading(false);
        })();
    }, [navigate]);

    // Return an empty array
    // as the hook doesn't expose any state
    return { loading };
};